package uk.co.nickthecoder.kojak

/**
 * As this is a multi-platform project, the JVM `Writer` interface isn't available, so we define a similar interface here.
 *
 * When used from a JVM context, see `WriterShim`.
 *
 * Alas, that means we need wrappers to make use of JVM classes, because the JVM doesn't support duck-typing.
 * i.e. Even though this interface has a similar structure to JVM's Writer interface, we cannot cast between the
 * two types.
 *
 * NOTE. This only defines the parts of the JVM's Writer class that this project requires
 */
interface MPPWriter : AutoCloseable {
    fun append(value: String): MPPWriter
    fun append(value: Char): MPPWriter

    fun write(c: Int) {
        append(c.toChar())
    }

    fun write(charArray: CharArray) {
        write(charArray, 0, charArray.size)
    }

    fun write(string: String, offset: Int, length: Int)

    fun write(charArray: CharArray, offset: Int, length: Int)

    fun flush()

    override fun close()
}

class MPPStringWriter : MPPWriter {
    private val stringBuilder = StringBuilder()

    override fun append(value: String): MPPWriter {
        stringBuilder.append(value)
        return this
    }

    override fun append(value: Char): MPPWriter {
        stringBuilder.append(value)
        return this
    }

    override fun write(charArray: CharArray, offset: Int, length: Int) {
        stringBuilder.appendRange(charArray, offset, offset + length)
    }

    override fun write(string: String, offset: Int, length: Int) {
        stringBuilder.appendRange(string, offset, offset + length)
    }

    override fun flush() {}
    override fun close() {}

    override fun toString() = stringBuilder.toString()
}
